// *****************
// MenuConfig = pc_menuconfig.jsx
// autor: W de Paula / MVinfo
// data: 16/10/24 | 14:10h
// *****************




// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from "react-router-dom";
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

// import { Howl } from 'howler';
import Swal from 'sweetalert2';
// import SomNotificacao from '../../../../Assets/agendex/agendex-notification.mp3';

import './pc_menuconfig.css';

function PCMenuConfig(props) {
    const [QtNotificacoesAtual, setQtNotificacoesAtual] = useState(0); 
    const [userInteracted, setUserInteracted] = useState(false); // Novo estado para rastrear a interação do usuário
    const navigate = useNavigate();

    // const tocarSom = () => {
    //     const sound = new Howl({
    //         src: [SomNotificacao],
    //         volume: 1.0,
    //     });
    //     sound.play();
    // };

    // const vibrarDispositivo = () => {
    //     if ('vibrate' in navigator) {
    //         navigator.vibrate(1000);
    //     }
    // };

    // const iconeSininho = () => {
    //     return (
    //         <div style={{ position: 'relative' }}>
    //             <i className={`bi ${QtNotificacoesAtual > 0 ? 'bi-bell' : 'bi-bell-o'} fs-2`} style={{ color: QtNotificacoesAtual > 0 ? 'yellow' : 'inherit' }} />
    //             {QtNotificacoesAtual > 0 && (
    //                 <span
    //                     style={{
    //                         position: 'absolute',
    //                         top: '-10px',
    //                         right: '-10px',
    //                         background: 'red',
    //                         color: 'white',
    //                         borderRadius: '50%',
    //                         padding: '5px',
    //                         minWidth: '20px',
    //                         textAlign: 'center'
    //                     }}>
    //                     {QtNotificacoesAtual}
    //                 </span>
    //             )}
    //         </div>
    //     );
    // };

    const handleLogoutClick = () => {
        Swal.fire({
            title: 'Confirma Logof?',
            text: 'Ao fazer logof (sair de sua conta) você será desconectado desta seção. Será necessário fazer Login novamente para ter acesso ao Agendex Web',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, encerrar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                LogoutComponent();
                navigate('/app/login/prestador');
            }
        });
    };

    function LogoutComponent() {
        localStorage.removeItem("tokenlg");
        localStorage.removeItem("tokenapw");
        localStorage.removeItem("tokenasw");
    };

    const handleSobreClick = () => {

        Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: true,
            icon: 'info',
            title: 'Agendex Colaborador® Web. Version 1.0.4. Copyright © 2021-2025 .',
            text: '(c)Agendex. All-in-one. Minha Agenda. Agenda Profissional.  Microvolution Informática, by WMX Group. All Rights Reserved. Todos os Direitos Reservados. (25/10/25)'
        });
    };
    
    return (
        <div className="container-menu-config">
            <div className="title-menu-config">
                {/* <Link to="/app/colaborador/notificacoes" className="" aria-current="page">
                    {iconeSininho()}
                </Link> */}
                <div className="dropdown">
                    <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="bi bi-three-dots-vertical fs-5"></i>
                    </button>
                    <ul className="dropdown-menu">
                        <li><button className="dropdown-item disabled" type="button">Tamanho Fonte</button></li>
                        <li><button className="dropdown-item disabled" type="button">Tema Escuro</button></li>


                        {/* *********** sub menu notificações internas ************** */}
                        {/* <li> */}
                            {/* ******* tablet, NB, PC ********* */}
                            {/* <Link to="/app/colaborador/config/notificacoes" className={`dropdown-item dropdown-item-full props.page === "notificacoesinternas"`} aria-current="page">
                                <i className="bi bi-bell-slash"></i> <span className="ms-1 d-sm-inline menu-title">Notificações Internas</span>
                            </Link> */}
                            {/* ******** celular ********* */}
                            {/* <Link to="/app/colaborador/config/notificacoes" className={`dropdown-item dropdown-item-short props.page = "notificacoesinternas"`} aria-current="page">
                                <i className="bi bi-bell-slash"></i> <span className="ms-1 d-sm-inline">Notificações</span>
                            </Link>
                        </li> */}
                        {/* *********** sub menu notificações internas ************** */}


                        {/* *********** sub menu fale conosco ************** */}
                        {/* <li> */}
                            {/* ******* tablet, NB, PC ********* */}
                            {/* <Link to="/app/colaborador/config/faleconosco" className={`dropdown-item dropdown-item-full disabled props.page === "notificacoesinternas"`} aria-current="page">
                                <i className="bi bi-chat-dots"></i> <span className="ms-1 d-sm-inline menu-title">Fale Conosco</span>
                            </Link> */}
                            {/* ******** celular ********* */}
                            {/* <Link to="/app/colaborador/config/faleconosco" className={`dropdown-item dropdown-item-short disabled props.page = "notificacoesinternas"`} aria-current="page">
                                <i className="bi bi-chat-dots"></i> <span className="ms-1 d-sm-inline">Fale Conosco</span>
                            </Link>
                        </li> */}
                        {/* *********** sub menu fale conosco ************** */}


                        {/* *********** sub menu Sobre o Agendex ************** */}
                        <li>
                            {/* ******* tablet, NB, PC ********* */}
                            <button 
                                className="dropdown-item dropdown-item-full" type="button" onClick={handleSobreClick}>
                                <i className="bi bi-info-circle-fill"></i> <span className="ms-1 d-sm-inline menu-title">Sobre o Agendex Web</span>                            </button>
                            {/* ******** celular ********* */}
                            <button 
                                className="dropdown-item dropdown-item-short" type="button" onClick={handleSobreClick}>
                                <i className="bi bi-info-circle"></i> <span className="ms-1 d-sm-inline">Sobre</span>
                            </button>
                        </li>
                        {/* *********** sub menu Sobre o Agendex ************** */}


                        <hr />
                        {/* *********** sub menu fazer logout ************** */}
                        <li>
                            {/* ******* tablet, NB, PC ********* */}
                            <button 
                                className="dropdown-item dropdown-item-full" type="button" onClick={handleLogoutClick}>
                                <i className="bi bi-box-arrow-right"></i> <span className="ms-1 d-sm-inline menu-title">Sair da Conta(Logout)</span>
                            </button>
                            {/* ******** celular ********* */}
                            <button 
                                className="dropdown-item dropdown-item-short" type="button" onClick={handleLogoutClick}>
                                <i className="bi bi-box-arrow-right"></i> <span className="ms-1 d-sm-inline">Logout</span>
                            </button>
                        </li>
                        {/* *********** sub menu fazer logout ************** */}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default PCMenuConfig;